import { Button, Flex, Text } from "@gravity-ui/uikit";
import { motion } from "framer-motion";
import { appConfig } from "src/config";
import { useGravityDevice } from "src/hooks/useGravityDevice";
import { T, useTranslate } from "src/i18n";

import { Chart } from "./components";
import css from "./MainBlock.module.scss";

export const MainBlock = () => {
  const { t } = useTranslate();
  const { isMobile, isTablet, deviceText } = useGravityDevice();
  const contactSubject = t(
    "landing.contact_us.email_subject",
    "Запрос на демо {name}",
    { name: appConfig.displayName },
  );
  const contactMailto = `mailto:${appConfig.contactEmail}?subject=${encodeURIComponent(contactSubject)}`;

  return (
    <Flex
      direction={"column"}
      alignItems={"center"}
      justifyContent={"space-between"}
      maxWidth={"1440px"}
      className={css.mainBlockContainer}
      style={{
        paddingLeft: isMobile ? 30 : 50,
        paddingRight: isMobile ? 30 : 50,
        paddingTop: isMobile ? 0 : 40,
      }}
    >
      <Flex direction={"column"} gap={6}>
        <motion.div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: [60, -8, 0] }}
          transition={{
            duration: 0.5,
            ease: [0.4, 0.0, 0.2, 1],
          }}
        >
          <Text
            as="h1"
            variant={isMobile ? "display-2" : "display-3"}
            style={{
              lineHeight: 1,
              textAlign: isMobile ? "start" : "center",
              maxWidth: isMobile ? "100%" : "80%",
            }}
          >
            <T
              keyName="landing.main_block.header"
              defaultValue="Автоматизируйте интернет-магазин. Товары обновляются, пока вы занимаетесь продажами."
            />
          </Text>
        </motion.div>
        <motion.div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 16,
          }}
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: [60, -8, 0] }}
          transition={{
            delay: 0.2,
            duration: 0.5,
            ease: [0.4, 0.0, 0.2, 1],
          }}
        >
          <Text
            as="h2"
            variant={isMobile ? "body-1" : isTablet ? "body-2" : "body-3"}
            style={{
              lineHeight: 1.0,
              textAlign: isMobile ? "start" : "center",
            }}
          >
            <T
              keyName="landing.main_block.subheader.1"
              defaultValue="Автозагрузка ассортимента, цен, остатков и размеров - никакого ручного ввода"
            />
          </Text>
          <Text
            as="h2"
            variant={isMobile ? "body-1" : isTablet ? "body-2" : "body-3"}
            style={{
              lineHeight: 1.0,
              textAlign: isMobile ? "start" : "center",
            }}
          >
            <T
              keyName="landing.main_block.subheader.2"
              defaultValue="Интеграция с Insales, WooCommerce и любой CMS (включая самописные)"
            />
          </Text>
        </motion.div>
      </Flex>

      <Flex width={"100%"} alignItems={"center"} justifyContent={"center"}>
        <div
          className={css.chartContainer}
          style={{
            padding: isMobile ? 10 : 15,
          }}
        >
          <Text variant={deviceText.subheader}>
            <T
              keyName="landing.main_block.chart.title"
              defaultValue="Средняя прибыль клиентов"
            />
          </Text>
          <Chart />
        </div>
      </Flex>

      <motion.div
        initial={{ opacity: 0, y: 60 }}
        animate={{ opacity: 1, y: [60, -8, 0] }}
        transition={{
          delay: 0.4,
          duration: 0.5,
          ease: [0.4, 0.0, 0.2, 1],
        }}
      >
        <Flex
          direction="column"
          gap={3}
          alignItems="center"
          className={css.ctaGroup}
        >
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            animate={{
              y: [0, -5, 0],
              transition: {
                duration: 1,
                ease: "easeInOut",
                repeat: Infinity,
                repeatDelay: 1,
              },
            }}
            className={css.wrapper}
          >
            <motion.div
              className={css.pulseRing}
              animate={{
                scale: [0.8, 1.1],
                opacity: [0.5, 0],
              }}
              transition={{
                duration: 2,
                ease: "easeInOut",
                repeat: Infinity,
                repeatDelay: 1,
              }}
            />
            <Button
              className={css.button}
              view="action"
              size="xl"
              width="max"
              href="/authorization/reg"
            >
              <T
                keyName="landing.try_free"
                defaultValue="Попробовать бесплатно"
              />
            </Button>
          </motion.div>
          <Text variant="body-2" color="secondary">
            <T keyName="landing.contact_us.prefix" defaultValue="или" />{" "}
            <a className={css.contactLink} href={contactMailto}>
              <T keyName="landing.contact_us" defaultValue="связаться с нами" />
            </a>
          </Text>
        </Flex>
      </motion.div>
    </Flex>
  );
};
